export { default as Door } from './door';
